import * as bootstrap from "bootstrap";
import React, { useEffect, useState } from "react";
import { useRef } from "react";
import { useLocation } from "react-router-dom";
import { NavLink } from "react-router-dom";
import "./Navbar.css";
import logo from "./images/logo2.jpg";
import logoBlue from "./images/logo.png";
import { FaHouse, FaUsers, FaGear, FaBug, FaPhone, } from "react-icons/fa6";
import { FaSignInAlt } from "react-icons/fa";


const Navbar = () => {
  const location = useLocation();
  const navRef = useRef();
  const [menuOpen, setMenuOpen] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  const closeNavbar = () => {

    const offcanvasElement =
      document.getElementById("mobileMenu");

    const bsOffcanvas =
      bootstrap.Offcanvas.getInstance(offcanvasElement);

    if (bsOffcanvas) {
      bsOffcanvas.hide();
    }

    document.body.classList.add("offcanvas-open");

    const backdrop =
      document.querySelector(".offcanvas-backdrop");

    if (backdrop) {
      backdrop.remove();
    }
  };
  const getPageName = () => {

    switch (location.pathname) {

      case "/":
        return "Total Pest Control";

      case "/about":
        return "About Us";

      case "/services":
        return "Services";

      case "/pest":
        return "Pest";

      case "/contact":
        return "Contact Us";

      case "/login":
        return "Login";

      default:
        return "Total Pest Control";
    }

  };
  return (
    <>

      {/* NAVBAR */}

      <nav
        className={`navbar navbar-expand-lg custom-navbar px-lg-5 px-3 ${scrolled ? "scrolled" : ""
          }`}
      >
        <div className="container-fluid">

          {/* LOGO */}
          <NavLink className="navbar-brand d-flex align-items-center" to="/">
            <img
              src={scrolled ? logo : logoBlue}
              alt="logo"
              height="68"
            />
            <span className="brand-text ms-2 desktop-brand">
              Total Pest Control
            </span>

            <span className="brand-text ms-2 mobile-brand">
              {getPageName()}
            </span>
          </NavLink>


          {/* TOGGLER */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={() => {

              const offcanvasElement =
                document.getElementById("mobileMenu");

              const bsOffcanvas =
                new bootstrap.Offcanvas(offcanvasElement);

              bsOffcanvas.show();
            }}
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          {/* DESKTOP LINKS */}

          <div className="collapse navbar-collapse justify-content-end d-none d-lg-flex">

            <ul className="navbar-nav gap-lg-4">

              <li className="nav-item">
                <NavLink className="nav-link" to="/">Home</NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/about">About Us</NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/services">Services</NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/pest">Pest</NavLink>
              </li>

              <li className="nav-item">
                <NavLink className="nav-link" to="/contact">Contact Us</NavLink>
              </li>

              <li className="nav-item ms-lg-3">
                <a
                  href="https://crm.totalpestcontrol.co.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="login-btn"
                >
                  <FaSignInAlt className="login-icon" />
                  Login
                </a>
              </li>

            </ul>

          </div>
        </div>
      </nav>
      {/* MOBILE MENU */}

      <div
        className="offcanvas offcanvas-end"
        tabIndex="-1"
        id="mobileMenu"
      >

        <div className="offcanvas-body">

          <ul className="navbar-nav gap-4">

            <li className="nav-item">
              <NavLink className="nav-link" to="/" onClick={closeNavbar} >
                <FaHouse className="mobile-icon" /> Home
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/about" onClick={closeNavbar}>
                <FaUsers className="mobile-icon" /> About Us
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/services" onClick={closeNavbar}>
                <FaGear className="mobile-icon" /> Services
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/pest" onClick={closeNavbar}>
                <FaBug className="mobile-icon" /> Pest
              </NavLink>
            </li>

            <li className="nav-item">
              <NavLink className="nav-link" to="/contact" onClick={closeNavbar}>
                <FaPhone className="mobile-icon" /> Contact Us
              </NavLink>
            </li>

            <li className="nav-item">

              <a
                href="https://crm.totalpestcontrol.co.in"
                target="_blank"
                rel="noopener noreferrer"
                className="login-btn"
                onClick={closeNavbar}
              >
                Login
              </a>
            </li>

          </ul>

        </div>

      </div>


    </>
  );
};

export default Navbar;















